import { escape, get } from 'lodash'

import { Colors, Services, getPrice } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons, isStringNotEmpty, labelModes, permissionPresets, sizes, states } from '@/utils'

import button from '@/components/button'
import filterSendings from '@/components/button/filter/sendings'
import buttonReport from '@/components/button/report'
import entityInfo from '@/components/entity/info'
import preloader from '@/components/preloader'
import billingsForm from '@/components/services/billings/form'
import documentTemplatesGenerateButton from '@/components/services/documentTemplates/generate/button'
import eventsHistoryTab from '@/components/services/eventsHistory/tab'
import userComments from '@/components/services/userComments/template'
import usersBalance from '@/components/services/users/balance'
import form from '@/components/services/users/form'
import sticker from '@/components/sticker'
import tag from '@/components/tag'
import textOverflow from '@/components/text/overflow'

function renderReportButton(h) {
  if (this.checkPermissions(`advanced.${Services.reports}.presetUsersBalance`, permissionPresets.resellerUp)) {
    return h(
      buttonReport,
      {
        props: {
          icon: false,
          type: 'list-item',
          preset: 'users_balance'
        }
      }
    )
  }
}
function renderUserCreateDialog(h) {
  return h(
    components.dialog,
    {
      props: {
        value: this.showUserCreateDialog,
        title: this.getTranslate(`${Services.users}.titles.create`),
        maxWidth: 800
      },
      on: {
        input: event => {
          return this.showUserCreateDialog = event
        }
      }
    },
    [
      h(
        form,
        {
          props: {
            isNew: true,
            value: this.restData[Services.users].create.data
          },
          on: {
            input: event => {
              this.restData[Services.users].create.data = event
            },
            validation: event => {
              this.restData[Services.users].create.isValid = event
            }
          }
        }
      ),
      h(
        'div',
        {
          class: 'faic fjcfe grid-gap--8 pa-2',
          slot: 'footer'
        },
        [
          h(
            button,
            {
              props: {
                mode: buttonModes.flat,
                label: this.getTranslate('misc.buttons.cancel'),
                disabled: this.restData[Services.users].create.state === states.loading
              },
              on: {
                click: () => {
                  this.showUserCreateDialog = false
                }
              }
            }
          ),

          h(
            button,
            {
              props: {
                label: this.getTranslate('misc.buttons.create'),
                loading: this.restData[Services.users].create.state === states.loading,
                disabled: !this.restData[Services.users].create.isValid,
                color: Colors.primary
              },
              on: {
                click: () => {
                  this.createUser()
                }
              }
            }
          )
        ]
      )
    ]
  )
}
function renderCreateListItem(h) {
  return h(
    components['list-item'],
    {
      props: {
        color: Colors.secondary,
        label: this.getTranslate(`${Services.users}.titles.create`),
        dense: true
      },
      on: {
        click: () => {
          this.showUserCreateDialog = true
        }
      }
    }
  )
}
function renderBalance(h, item) {
  const currency = get(item.settings, `${Services.billings}.currency`, this.globalSettings.billings.currency)
  const overdraft = get(item.settings, `${Services.billings}.overdraft`, 0)

  let balanceColor
  if (item.balance < 0) {
    balanceColor = Colors.error
  } else if (item.balance == 0) {
    balanceColor = Colors.grey
  } else {
    balanceColor = Colors.success
  }

  return h(
    tag,
    {
      props: {
        label: getPrice(item.balance, { currency }),
        size: sizes.tiny,
        color: balanceColor,
        tooltip: this.getTranslate(`${Services.users}.tooltips.overdraft`, { overdraft: getPrice(overdraft, { currency }) })
      }
    }
  )
}
function renderUsername(h, item) {
  return h(
    textOverflow,
    {
      class: 'mlpx-7',
      props: {
        value: item.username
      }
    }
  )
}
function renderHasContract(h, item) {
  const hasContract = get(item, 'data.partnership.hasContract') || get(item, '$verified', false)

  let hasContractColor
  if (hasContract) {
    hasContractColor = Colors.info
  } else {
    hasContractColor = Colors.grey
  }

  return h(
    tag,
    {
      props: {
        label: this.getTranslate(`${Services.users}.labels.data.partnership.hasContract.${hasContract}`),
        size: sizes.tiny,
        color: hasContractColor
      }
    }
  )
}
function renderInfo(h, item) {
  return h(
    'div',
    {
      class: 'faic grid grid-gap--4',
      style: { 'grid-template-columns': '1fr auto' }
    },
    [
      renderUsername.call(this, h, item),
      renderBalance.call(this, h, item)
    ]
  )
}
function renderReseller(h, item) {
  if (this.checkPermissions(`advanced.${Services.users}.get`, permissionPresets.managerUp)) {
    const reseller = get(item, 'Reseller.username')
    if (reseller) {
      return h(
        tag,
        {
          props: {
            label: reseller,
            size: sizes.tiny,
            color: Colors.primary,
            tooltip: this.getTranslate(`${Services.users}.tooltips.reseller`, { reseller })
          }
        }
      )
    }
  }
}
function renderManager(h, item) {
  if (this.checkPermissions(`advanced.${Services.users}.get`)) {
    const manager = get(item, 'data.partnership.Manager.username')
    if (manager) {
      return h(
        tag,
        {
          props: {
            label: manager,
            size: sizes.tiny,
            color: Colors.epic,
            tooltip: this.getTranslate(`${Services.users}.tooltips.manager`, { manager })
          }
        }
      )
    }

    return h(
      tag,
      {
        props: {
          label: this.getTranslate(`${Services.users}.labels.no.manager`),
          size: sizes.tiny,
          color: Colors.grey
        }
      }
    )
  }
}
function renderResellerAndManager(h, item) {
  return h(
    'div',
    {
      class: 'faic grid-gap--4'
    },
    [
      renderReseller.call(this, h, item),
      renderManager.call(this, h, item)
    ]
  )
}
function renderAbsolutePreloader(h, trigger) {
  if (trigger) {
    return h(
      'div',
      {
        class: 'preloader__holder preloader__holder--absolute'
      },
      [ h(preloader) ]
    )
  }
}
function renderSearchGeneratorItem(h, item, loading) {
  return h(
    'router-link',
    {
      class: {
        'search-generator__item': true,
        'search-generator__item--users': true,
        'search-generator__item--active': item.id === this.$route.params.id
      },
      props: {
        to: {
          name: `${Services.users}.single`,
          params: { id: item.id }
        }
      },
      directives: [
        {
          name: components.tooltip,
          value: this.getTranslate(`${Services.users}.tooltips.user`, {
            firstName: item.data.firstName ?? '',
            lastName: item.data.lastName ?? '',
            phone: item.data.phone ?? '',
            email: item.data.email ?? ''
          }),
          options: {
            placement: 'top-end'
          }
        }
      ],
      key: item.id
    },
    [
      h(
        'div',
        {
          class: 'grid grid-gap--4 pxpx-2'
        },
        [
          renderInfo.call(this, h, item),

          h(
            'div',
            {
              class: 'faic fjcsb grid-gap--4'
            },
            [
              renderHasContract.call(this, h, item),
              renderResellerAndManager.call(this, h, item)
            ]
          )
        ]
      ),

      renderAbsolutePreloader.call(this, h, loading)
    ]
  )
}
function renderSearchGenerator(h) {
  return h(
    'search-generator',
    {
      scopedSlots: {
        default: ({ item, loading }) => {
          return renderSearchGeneratorItem.call(this, h, item, loading)
        },
        report: () => {
          return renderReportButton.call(this, h)
        },
        create: () => {
          return renderCreateListItem.call(this, h)
        }
      }
    }
  )
}

function renderTokenDialog(h) {
  if (this.checkPermissions('secret.loginAs', permissionPresets.resellerUp)) {
    let tokenDialogMaxWidth
    if (this.viewport.breakpoint.mdUp) {
      tokenDialogMaxWidth = 500
    }

    let tokenHint
    if (isStringNotEmpty(this.token)) {
      tokenHint = `${this.token.length}`
    } else {
      tokenHint = '0'
    }

    return h(
      components.dialog,
      {
        props: {
          title: this.getTranslate('misc.token'),
          value: this.showTokenDialog,
          maxWidth: tokenDialogMaxWidth
        },
        on: {
          input: event => {
            this.showTokenDialog = event
          }
        }
      },
      [
        h(
          'div',
          {
            class: 'pa-3'
          },
          [
            h(
              'g-textarea',
              {
                props: {
                  value: this.token,
                  hint: tokenHint,
                  labelMode: labelModes.hidden,
                  grow: true,
                  rounded: true,
                  readonly: true
                }
              }
            )
          ]
        ),

        h(
          'div',
          {
            class: 'fjcfe facfe grid-gap--8 pa-2',
            slot: 'footer'
          },
          [
            h(
              button,
              {
                props: {
                  label: this.getTranslate('misc.buttons.close'),
                  mode: buttonModes.flat
                },
                on: {
                  click: () => {
                    return this.closeTokenDialog()
                  }
                }
              }
            ),

            h(
              button,
              {
                props: {
                  label: this.getTranslate('misc.buttons.copy'),
                  color: Colors.primary
                },
                on: {
                  click: () => {
                    return this.copyToken()
                  }
                }
              }
            )
          ]
        )
      ]
    )
  }
}
function renderLoginAsButton(h) {
  return h(
    button,
    {
      props: {
        icon: icons.exit_to_app,
        mode: buttonModes.flat,
        color: Colors.epic,
        loading: this.statusLoginAs === states.loading,
        disabled: this.statusLoginAs === states.loading || !this.checkPermissions('secret.loginAs', permissionPresets.resellerUp)
      },
      on: {
        mousedown: this.clickHandler,
        mouseup: this.clickHandler,
        touchstart: this.clickHandler,
        touchend: this.clickHandler
      },
      scopedSlots: {
        dialog: () => {
          return renderTokenDialog.call(this, h)
        }
      }
    }
  )
}
function renderUserInfo(h, data) {
  const { firstName, lastName } = data.data

  let userIconSVG
  let userColor
  if (data.$verified) {
    userIconSVG = 'user-verified'
    userColor = Colors.info
  } else {
    userIconSVG = 'user'
    userColor = Colors.grey
  }

  return h(
    sticker,
    {
      props: {
        value: data.username,
        label: [ firstName, lastName ].filter(Boolean).map(escape).join(' '),
        iconSVG: userIconSVG,
        color: userColor,
        copy: true,
        maxWidth: 300
      }
    }
  )
}
function renderTemplateTitle(h, data) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8 faic',
      style: { 'grid-template-columns': 'auto 1fr auto' }
    },
    [
      renderLoginAsButton.call(this, h),
      renderUserInfo.call(this, h, data)
    ]
  )
}

function renderFilterSendingsByOwnerButton(h, id) {
  return h(
    filterSendings,
    {
      props: {
        query: {
          ownerId: id
        }
      }
    }
  )
}
function renderBalanceButton(h, data) {
  const currency = get(data.settings, `${Services.billings}.currency`, this.globalSettings.billings.currency)

  return h(
    usersBalance,
    {
      props: {
        currency,
        UserId: data.id
      }
    }
  )
}
function renderAddFundsDialog(h, { id, settings }) {
  if (this.checkPermissions(`advanced.${Services.billings}.generate`, permissionPresets.resellerUp)) {
    return h(
      components.dialog,
      {
        props: {
          title: this.getTranslate(`${Services.users}.titles.add.funds`),
          value: this.showAddFundsDialog,
          maxWidth: 500
        },
        on: {
          input: event => {
            this.showAddFundsDialog = event
          }
        }
      },
      [
        h(
          billingsForm,
          {
            props: {
              value: this.restData.billings.create.data,
              errors: this.restData.billings.create.errors,
              owner: id,
              currency: get(settings, `${Services.billings}.currency`)
            },
            on: {
              input: event => {
                this.restData.billings.create.data = event
              },
              validation: event => {
                this.restData.billings.create.isValid = event
              }
            }
          }
        ),

        h(
          'div',
          {
            class: 'faic fjcfe grid-gap--8 pa-2',
            slot: 'footer'
          },
          [
            h(
              button,
              {
                props: {
                  label: this.getTranslate('misc.buttons.cancel'),
                  mode: buttonModes.flat
                },
                on: {
                  click: () => {
                    this.showAddFundsDialog = false
                  }
                }
              }
            ),
            h(
              button,
              {
                props: {
                  label: this.getTranslate('misc.buttons.create'),
                  loading: this.restData.billings.create.state === 'loading',
                  disabled: !this.createDataIsValid,
                  color: 'primary'
                },
                on: {
                  click: () => {
                    return this.createBilling()
                  }
                }
              }
            )
          ]
        )
      ]
    )
  }
}
function renderAddFundsButton(h, { id, settings }) {
  return h(
    button,
    {
      props: {
        icon: icons.add,
        mode: buttonModes.flat,
        color: Colors.secondary,
        tooltip: this.getTranslate(`${Services.users}.tooltips.add.funds`),
        disabled: !this.checkPermissions(`advanced.${Services.billings}.generate`, permissionPresets.resellerUp)
      },
      on: {
        click: () => {
          this.restData.billings.create.data.OwnerId = id
          this.showAddFundsDialog = true
        }
      },
      scopedSlots: {
        dialog: () => {
          return renderAddFundsDialog.call(this, h, {
            id,
            settings
          })
        }
      }
    }
  )
}
function renderDocumentButton(h, data) {
  let { id: OwnerId, ResellerId } = data
  ResellerId = get(data, 'Reseller.id', ResellerId)

  return h(
    documentTemplatesGenerateButton,
    {
      props: {
        OwnerId,
        ResellerId
      }
    }
  )
}
function renderTemplateHeader(h, data) {
  return h(
    'div',
    {
      class: 'flex grid-gap--8 fjcfe'
    },
    [
      renderFilterSendingsByOwnerButton.call(this, h, data.id),
      renderBalanceButton.call(this, h, data),
      renderAddFundsButton.call(this, h, data),
      renderDocumentButton.call(this, h, data)
    ]
  )
}
function renderTemplateAfterForm(h, data) {
  return h(
    entityInfo,
    {
      props: {
        value: data
      }
    }
  )
}
function renderTabContent(h, data) {
  switch (this.tab) {
    case Services.userComments: return h(userComments(data.id))
    case Services.eventsHistory: {
      return h(
        eventsHistoryTab,
        {
          props: {
            entityId: this.$route.params.id
          }
        }
      )
    }
  }
}
function renderTab(h, tab, data) {
  return h(
    components.card,
    {
      props: {
        rounded: true,
        outline: true,
        width: '100%'
      },
      key: tab
    },
    [ renderTabContent.call(this, h, data) ]
  )
}
function renderTemplateRight(h, data) {
  if (this.tabs.length) {
    return h(
      'div',
      {
        class: 'grid grid-gap--8'
      },
      [
        h(
          components['tabs-header'],
          {
            props: {
              value: this.tab,
              tabs: this.tabs
            },
            on: {
              input: event => {
                this.tab = event
              }
            }
          }
        ),

        h(
          components.tabs,
          {
            props: { value: this.tab },
            scopedSlots: {
              body: () => {
                return this.tabs.map(tab => {
                  return renderTab.call(this, h, tab.key, data)
                })
              }
            }
          }
        )
      ]
    )
  }
}
function renderTemplate(h) {
  return h(
    'legacy-template',
    {
      scopedSlots: {
        title: ({ data }) => {
          return renderTemplateTitle.call(this, h, data)
        },
        header: ({ data }) => {
          return renderTemplateHeader.call(this, h, data)
        },
        'after-form': ({ data }) => {
          return renderTemplateAfterForm.call(this, h, data)
        },
        right: ({ data }) => {
          return renderTemplateRight.call(this, h, data)
        }
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: Services.users
    },
    [
      renderSearchGenerator.call(this, h),
      renderUserCreateDialog.call(this, h),
      renderTemplate.call(this, h)
    ]
  )
}
